import React, { memo } from "react";

export const Dash = memo<React.HTMLProps<HTMLSpanElement>>((props) => <span {...props}>&mdash;</span>);
